import axios from 'axios'
import React, { useState, useEffect } from 'react'
import Big from '../assets/images.png'
const Weather = () => {
    const apiKey = "af364ac5e964f71bcd669b3022e2262e"
    const [inputCity, setInputCity] = useState('')
    const [data, setData] = useState({});

    const getApiData = (cityName) => {
        if (!cityName) return
        const apiURL = "https://api.openweathermap.org/data/2.5/weather?q= " + cityName + " &appid=" + apiKey
        axios.get(apiURL).then((res) => {
            setData(res.data)
        }).catch((err) => {
            console.log(err)
        })
    }

    const searchClick = () => {
        if (!inputCity) {
            alert('Please enter city name And know the weather of your city 😉')
        } else {
            getApiData(inputCity);
            setInputCity('')
        }
    }

    const handleOnChange = (e) => {
        setInputCity(e.target.value)
    }

    useEffect(() => {
        getApiData('Purnia')
    }, [])

    return (
        <>
            <div className='bacImg'>
                <div className='container'>
                    <h3 className='wea_ther'>Your Smart Weather App</h3>
                    <div className='row justify-content-center palto' style={{ marginTop: 50, paddingBottom: 200 }}>
                        <div className='col-lg-6 col-md-8 col-12 mb-4'>
                            <div className='card px-3 py-4 card_weath'>
                                <h3 className='pt-3 En_ter'><b>Enter City Details</b></h3>
                                <input type="text" onKeyPress={(e) => e.key === "Enter" ? searchClick() : null} className='form-control mt-4 weather_inputs' onChange={handleOnChange} value={inputCity} />
                                <button className='btn btn-rimary mt-3 mb-5 ' onClick={searchClick}>Search</button>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-8 col-12 mb-4'>
                            <div className='card px-3 py-4 card_weath'>
                                <div className='text-center pb-3'>
                                    <img src={Big} className="img_fluid" alt="logo" />
                                    <h4 className='weather_city pt-3'>{data?.name}</h4>
                                    <h5 className='wea_temp'>{((data?.main?.temp) - 273.15).toFixed(2)}°C</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Weather